import {
  PERFORMANCESCORE_LOADING,
  GET_PERFORMANCESCORE,
  GET_PERFORMANCESCORE_SUCCESS,
  GET_PERFORMANCESCORE_FAIL,
  ADD_PERFORMANCESCORE_SUCCESS,
  ADD_PERFORMANCESCORE_FAIL,
  DELETE_PERFORMANCESCORE_SUCCESS,
  DELETE_PERFORMANCESCORE_FAIL,
  UPDATE_PERFORMANCESCORE_SUCCESS,
  UPDATE_PERFORMANCESCORE_FAIL,
  PERFORMANCESCORE_RESET
} from "./actionType";

const INIT_STATE = {
  performanceScores: [],
  error: {},
};

const PerformanceScore = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCESCORE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCESCORE:
          return {
            ...state,
            performanceScores: action.payload.data,
            isPerformanceScoreCreated: false,
            isPerformanceScoreSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCESCORE_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCESCORE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformanceScoreCreated: false,
            isPerformanceScoreSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCESCORE: {
      return {
        ...state,
        isPerformanceScoreCreated: false,
        loading: true,
      };
    }

    case PERFORMANCESCORE_LOADING: {
      return {
        ...state,
        isPerformanceScoreCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCESCORE_SUCCESS:
      return {
        ...state,
        isPerformanceScoreCreated: true,
        loading: false,
        performanceScores: [action.payload.data, ...state.performanceScores],
      };

    case ADD_PERFORMANCESCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCESCORE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceScoreCreated: true,
        performanceScores: state.performanceScores.filter(
          performanceScore => performanceScore.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCESCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCESCORE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceScoreCreated: true,
        performanceScores: state.performanceScores.map(performanceScore =>
          performanceScore.id.toString() === action.payload.data.id.toString() ? { ...performanceScore, ...action.payload.data } : performanceScore
        ),
      };

    case UPDATE_PERFORMANCESCORE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCESCORE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PerformanceScore;